import template from 'lodash/template';
const clearKeymapTemplate = template(
  '这将清除键位设置——你确定要<%= action %>?'
);

export { clearKeymapTemplate };
